import { logger } from 'services/logger';

export default function gtagEvent(eventName: string, parameters?: null | Record<string, unknown>) {
    try {
        if (window.gtag) {
            window.gtag('event', eventName, parameters ?? undefined);
        }
    } catch (e) {
        logger.error(e);
    }
}

export function sendGtagPageView(overrides?: { path?: string; title?: string; location?: string }) {
    gtagEvent('page_view', {
        page_path: overrides?.path ?? window.location.pathname,
        page_title: overrides?.title ?? document.title,
        page_location: overrides?.location ?? window.location.href
    });
}
